import { Component, OnInit, Input } from '@angular/core';
import { WorkItemModel } from '../../../models/work-item';
import { BehaviorSubject } from 'rxjs';
import { UIMenuModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-menu-bootstrap',
  templateUrl: './e5core-ui-work-menu-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-menu-bootstrap.component.css']
})
export class E5CoreUiWorkMenuBootstrapComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() menuItems: UIMenuModel[] ;

  constructor() { }

  ngOnInit() {
  }

}
